import store from 'vue-src/store'
import {cleanObj} from "vue-src/utils"
import env from "vue-src/utils/constants"
import Vue from 'vue'
import Raven from 'raven-js'
const urlParse = require('url-parse')


const $ = window.jQuery
$.support.cors = true
let token = window.ix_token

export const IxApi = {
  'users': 'users/',
  'user_profile': 'users/profile/',
  'stockitems': 'stockitems/',
  'brands': 'brands/',
  'mxcategories': 'mxcategories/',
  'config': 'config/',
  'carts': 'carts/',
  'current_cart': 'carts/current/',
  'lineitems': 'lineitems/',
  'addresses': 'addresses/',
  'paymentmethods': 'paymentmethods/',
  'payments': 'payments/',
  'prices': 'prices/',
  'menus': 'menus/',
  'orders': 'orders/',
  'orders_status': 'orders/status/',
  'orders_status_alt': 'orders/status-alt/',
  'order_history': 'orders/order_history/',
  'order_history_local': 'orders/order_history_local/',
  'recent_purchases': 'orders/recent_purchases/',
  'recent_purchases_local': 'orders/recent_purchases_local/',
  'tabset': 'tabset/',
  'search_filtersets': 'search/filtersets/',
  'search': "search/",
  'logout': "users/logout/",
  'tokeninfo': "tokeninfo/",
  'video_categories': "video-categories/",
  'video_detail': "video-categories/detail/",
  'documents': "documents/",
}

const default_params = {
  'format': 'json'
}

function headers() {

  let stuff = {
    'Authorization': `${token.token_type} ${token.access_token}`,
  }
  return stuff
}

export const fixDomain = function (url) {
  if (/^(http|\/\/)/.test(url)) {
    return url
  }
  let return_domain = env.IX_API
  if (!return_domain) {
    switch (domain.toLowerCase()) {
      case('jedcosupply.com'):
        return_domain = '//jedco.itemextend.com/api/'
        break
      case('gqfmfg.com'):
      case('www.gqfmfg.com'):
        return_domain = '//gqf.itemextend.com/api/'
        break
      case('127.0.0.1'):
        return_domain = '//jedco-staging.localhost:8000/api/'
        break
      default:
        break
    }
  }

  return return_domain + url
}

let TOKEN_INFO = {
  active: true,
  client_id: '',
  username: null,
  token_type: 'access_token',
  exp:0,
  iss: '',
  scope: '',
  application: '',
}

Vue.observable(TOKEN_INFO)

async function getTokenInfo() {
  let response = {}
  try {
    response = await new Promise((res, rej) => {
      $.ajax({
        method: 'post',
        url: fixDomain(IxApi.tokeninfo),
        data: JSON.stringify({token: token.access_token}),
        headers: headers(),
        withCredentials: true,
        xhrFields: {
          withCredentials: true,
        },
        contentType: 'application/json; charset=UTF-8',
        processData: true,
      }).then(res, rej)
    })
    Object.keys(response).forEach(e=>{
      TOKEN_INFO[e] = response[e]
    })
    return response
  } catch (e) {

    if (e.status === 401) {
      return new Promise((res, rej) => {
        $.ajax('/o/refresh/').then((response) => {
          token = response
          getTokenInfo().then(res)
        }, (r) => {
          $.ajax('/o/logout').then(function (r2) {
            window.location.href = '/'
          })
        })
      })
    }
    throw new Error('Token Failed to refresh!')
  }
}

let domain = window.location.hostname,
    PROMISE_401 = getTokenInfo(),
    is401Resolved = false,
    RESOLVE_401 = undefined,
    REJECT_401 = undefined


async function doAjaxCall(path, params, reqHeaders, method = 'get', data = {}) {
  /**
   * doAjaxCall
   *
   * This function will perform an ajax call with the proper headers to the
   * given path/url and adding the parameters as a query string.
   *
   * This function will also wait for the PROMISE_401 Promise to resolve in
   * order to handle oauth tokens needing to be refreshed. once refreshed,
   * the promise will resolve and following calls will continue.
   *
   *
   * returns Promise
   */

  // first let's make sure we add the get parameters to the url
  const [baseUrl, search] = path.split('?')

  const searchParams = new URLSearchParams(search || "")

  for (const key in default_params || {}) {
    if (!searchParams.has(key)) {
      searchParams.append(key, default_params[key])
    }
  }
  for (const key in params || {}) {
    searchParams.append(key, params[key])
  }

  // next we await the 401 promise, in case another call is resolving a 401
  // refresh issue
  try {
    await PROMISE_401
  } catch (e) {
    return Promise.reject()
  }
  // we ultimately return a promise of our call
  return new Promise(function (doAjaxCallResolve, doAjaxCallReject) {


    // if the call is a GET then we don't need jquery data, because we
    // alread handled our parameters. otherwise we want to send json
    // formatted data
    let jquery_data = method === 'get' ? '' : JSON.stringify(data)


    // this is our ajax_call. headers needs to be called here to make sure
    // the tokens are up to date.
    let ajax_call = {
      'url': baseUrl + '?' + searchParams.toString(),
      'method': method,
      'data': jquery_data,
      'headers': Object.assign(headers(), reqHeaders),
      'xhrFields': {
        'withCredentials': false,
      },
      'withCredentials': true,
      'contentType': 'application/json; charset=UTF-8',
      'processData': true,
      //'statusCode': {401: handle401},
    }


    async function handleAlwaysCall(dataOrJqXhr, status, jqXhrOrMessage) {
      //debugLog(dataOrJqXhr, status, jqXhrOrMessage)
      switch (status) {
        case 'nocontent':
        case 'success':
          if (typeof RESOLVE_401 === "function") RESOLVE_401(true)
          huzzah(dataOrJqXhr, status, jqXhrOrMessage)
          break
        case 'error':
          if (dataOrJqXhr.status === 401) {
            try{
              PROMISE_401 = getTokenInfo()
              await PROMISE_401
              ajax_call.headers = Object.assign(headers(), reqHeaders)
              $.ajax(ajax_call).always(handleAlwaysCall)
            }catch (e) {
              window.location.href = window.location.href
            }
          } else if(dataOrJqXhr.status > 0) {
            Raven.setExtraContext({
              tokenInfo: TOKEN_INFO,
              data: dataOrJqXhr,
              status: status,
              message: jqXhrOrMessage,
              request: ajax_call,
            })
            oopsieDaisy(dataOrJqXhr, status, jqXhrOrMessage)
          }
      }
    }


    function huzzah(data, status, jqXhr) {
      /**
       * Handle a succesful response
       */
      doAjaxCallResolve({
        'status': jqXhr.status,
        'data': data,
        'jqXhr': jqXhr,
        'request': ajax_call,
      })
    }

    function oopsieDaisy(jqXhr, status, error) {
      /**
       * handled a rejected response
       */
      if (!(jqXhr.status === 401 && ajax_call._retry)) {
        doAjaxCallReject({
          'status': jqXhr.status,
          'error': error,
          'data': jqXhr.responseJSON,
          'jqXhr': jqXhr,
          'request': ajax_call,
        })
      } else {
        IxLogout(window.location.href)
      }
    }


    // Finally, the actual request
    $.ajax(ajax_call).always(handleAlwaysCall)


  })
}

export const IxFetch = function (path, params = {}, headers = {}) {
  return doAjaxCall(fixDomain(path), params, headers)
}

export const IxPost = function (path, data, params = {}, headers = {}) {
  return doAjaxCall(fixDomain(path), params, headers, 'post', data)
}

export const IxPut = function (path, data, params = {}, headers = {}) {
  return doAjaxCall(fixDomain(path), params, headers, 'put', data)
}

export const IxPatch = function (path, data, params = {}, headers = {}) {
  return doAjaxCall(fixDomain(path), params, headers, 'patch', data)
}

export const IxDelete = function (path, params = {}, headers = {}) {
  return doAjaxCall(fixDomain(path), params, headers, 'delete')
}

export const IxLogoutRedirect = function() {
    store.commit('order/clear')
    let url = fixDomain('').replace('api/', '') + 'accounts/logout/'
    url += '?next=' + encodeURIComponent(window.location.origin + '/o/logout/')
    window.location.href = url
}

export const IxLogout = function (url = '/') {
  /**
   * This ajax call is different because we are logged in, and we also need
   * to send cookies to expire the session. so we have our own function for
   * this call.
   */
  let ajax_call = {
    'url': fixDomain(IxApi.logout),
    'method': 'get',
    'headers': headers(),
    'xhrFields': {
      'withCredentials': true,
    },
    'withCredentials': true,
  }

  return new Promise((resolve, reject) => {

    Promise.all([
          new Promise((res, rej) => {
            $.ajax('/o/logout/').then(res, res)
          }),
          store.dispatch('emptyCart'),
          new Promise((res, rej) => {
            $.ajax(ajax_call).then(res, res)
          })])
        .then(() => {
          resolve(window.location.href = url)
        })
        .catch((...err) => {
          reject(...err)
        }).finally(() => {
          store.commit('order/clear')
        })
  })


}

export function getResellerDocuments() {
  return IxFetch(`${IxApi.documents}reseller-docs/`)
}

export function confirmCartReseller(cart_id) {
  return IxPut(`${IxApi.carts}${cart_id}/confirm-reseller/`, {})
}

export function testTokenScope(...scopes){
  if(TOKEN_INFO.scope){
    return (scopes.filter(e=>TOKEN_INFO.scope.includes(e)).length === scopes.length)
  }
  return false
}

export function tokenInspected (){return PROMISE_401}

export const APIDEBUGMODE = function () {
  window.IxApi = IxApi
  window.IxFetch = IxFetch
  window.IxPost = IxPost
  window.IxPatch = IxPatch
  window.IxPut = IxPut
  window.IxDelete = IxDelete
  window.testTokenScope = testTokenScope
  window.tokenInspected = tokenInspected
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/IxPlugin/api.js